export default {"src":"/_next/static/media/career-circular.5bb453b0.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};